"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateNewBundle = void 0;
var date_fns_1 = require("date-fns");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var query_string_1 = require("query-string");
var react_1 = require("react");
var react_query_1 = require("react-query");
var account_v3_1 = require("../apps/account-v3");
var api_1 = require("../apps/account-v3/api");
var utils_1 = require("../apps/account-v3/utils");
var subscriptions_api_1 = require("./subscriptions-api");
var ENABLE_EXISTING_CUSTOMER_NEW_BUNDLE_FLOW = false;
var EXISTING_CUSTOMER_NEW_BUNDLE = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ExistingCustomerNewBundle(\n    $addressId: Int!\n    $nextChargeScheduledAt: String!\n    $quantity: Int!\n    $shopifyVariantId: BigInt!\n    $intervalUnit: String!\n    $intervalFrequency: String!\n    $properties: [SubscriptionPropertiesInput]!\n    $discountRecipeKey: String\n    $itemUpdates: [SubscriptionItemUpdateInput]\n    $onetimes: [SubscriptionItemUpdateInput]\n  ) {\n    existingCustomerNewBundle(\n      addressId: $addressId\n      nextChargeScheduledAt: $nextChargeScheduledAt\n      quantity: $quantity\n      shopifyVariantId: $shopifyVariantId\n      intervalUnit: $intervalUnit\n      intervalFrequency: $intervalFrequency\n      properties: $properties\n      discountRecipeKey: $discountRecipeKey\n      itemUpdates: $itemUpdates\n      onetimes: $onetimes\n    ) {\n      id\n    }\n  }\n"], ["\n  mutation ExistingCustomerNewBundle(\n    $addressId: Int!\n    $nextChargeScheduledAt: String!\n    $quantity: Int!\n    $shopifyVariantId: BigInt!\n    $intervalUnit: String!\n    $intervalFrequency: String!\n    $properties: [SubscriptionPropertiesInput]!\n    $discountRecipeKey: String\n    $itemUpdates: [SubscriptionItemUpdateInput]\n    $onetimes: [SubscriptionItemUpdateInput]\n  ) {\n    existingCustomerNewBundle(\n      addressId: $addressId\n      nextChargeScheduledAt: $nextChargeScheduledAt\n      quantity: $quantity\n      shopifyVariantId: $shopifyVariantId\n      intervalUnit: $intervalUnit\n      intervalFrequency: $intervalFrequency\n      properties: $properties\n      discountRecipeKey: $discountRecipeKey\n      itemUpdates: $itemUpdates\n      onetimes: $onetimes\n    ) {\n      id\n    }\n  }\n"
    // working example: ?ecnb=1&aid=123456&drk=someKey (must be logged in)
    // ecnb = ExistingCustomerNewBundle, aid = Address ID, drk = Discount Recipe Key
])));
// working example: ?ecnb=1&aid=123456&drk=someKey (must be logged in)
// ecnb = ExistingCustomerNewBundle, aid = Address ID, drk = Discount Recipe Key
var getParamsFromQueryString = function () {
    var _a;
    var queryArgs = (0, query_string_1.parse)(window.location.search);
    // if the customer is not logged in or the URL indicates we should create a new bundle, return nothing
    if (!((_a = window.customer) === null || _a === void 0 ? void 0 : _a.rechargeHash) || !queryArgs.ecnb)
        return;
    // fetch the address ID parameter from the URL
    var addressId = Number(queryArgs.aid);
    var discountRecipeKey = queryArgs.drk;
    // only return something if addressId is present
    if (addressId)
        return { addressId: addressId, discountRecipeKey: discountRecipeKey };
};
var useCreateNewBundle = function (bundleType) {
    // init the API client
    var subscriptionsApiClient = (0, api_1.getSubscriptionAPIClient)();
    // grab the query params from the url
    var queryParams = (0, react_1.useMemo)(function () { return getParamsFromQueryString(); }, []);
    // init the mutation
    var _a = (0, react_query_1.useMutation)(function (variables) { return subscriptionsApiClient.request(EXISTING_CUSTOMER_NEW_BUNDLE, variables); }), mutateAsync = _a.mutateAsync, mutateError = _a.error;
    // init state variables to help with the UI
    var _b = __read((0, react_1.useState)(false), 2), isCreatingNewBundleForExistingCustomer = _b[0], setIsCreatingNewBundleForExistingCustomer = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), didExistingCustomerCreateNewBundle = _c[0], setDidExistingCustomerCreateNewBundle = _c[1];
    // fetch discount and recipe from subscriptions-api
    var _d = __read((0, react_1.useState)(), 2), discountRecipe = _d[0], setDiscountRecipe = _d[1];
    var _e = __read((0, react_1.useState)(), 2), existingDiscount = _e[0], setExistingDiscount = _e[1];
    // load and apply the discount recipe and existing discount if the query params are set
    (0, react_1.useEffect)(function () {
        var e_1, _a;
        var customerHash = (0, account_v3_1.getCustomerHash)();
        var discountRecipeFetchArgs = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.discountRecipeKey)
            ? (0, subscriptions_api_1.getClientArgs)({
                customerHash: customerHash,
                path: "/discount-recipes/".concat(queryParams.discountRecipeKey),
            })
            : null;
        var existingDiscountFetchArgs = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.addressId)
            ? (0, subscriptions_api_1.getClientArgs)({
                customerHash: customerHash,
                path: "/get-discount?aid=".concat(queryParams.addressId),
            })
            : null;
        try {
            for (var _b = __values([
                { fetchArgs: discountRecipeFetchArgs, setter: setDiscountRecipe },
                { fetchArgs: existingDiscountFetchArgs, setter: setExistingDiscount },
            ]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = _c.value, fetchArgs = _d.fetchArgs, setter = _d.setter;
                if (!fetchArgs)
                    continue;
                window
                    .fetch(fetchArgs.uri, { headers: fetchArgs.headers })
                    .then(function (res) { return res.json(); })
                    .then(setter)
                    .catch(console.error);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }, []);
    // for existing customers, compare the discount recipe key vs the existing discount
    // incorporate whichever one has the greater savings
    var getSavingsAndDiscount = function (price) {
        if (!ENABLE_EXISTING_CUSTOMER_NEW_BUNDLE_FLOW)
            return { savings: undefined, discount: undefined };
        return [discountRecipe, existingDiscount]
            .map(function (discount) {
            if (!discount || !discount.value)
                return {};
            if (!discountAppliesToNewBundleType(discount.custom.applies_to_bundle_types, bundleType))
                return {};
            if (discount.status !== 'enabled')
                return {};
            var savings = (function () {
                // for percentage discounts, calculate it from the total price (be sure to keep it as an integer for formatPrice)
                if (discount.discount_type === 'percentage')
                    return Math.floor(price * (discount.value / 100));
                // otherwise value is a dollar amount, so just convert it to cents
                else
                    return discount.value * 100;
            })();
            return { savings: savings, discount: discount };
        })
            .sort(function (d1, d2) { return ((d1.savings || 0) > (d2.savings || 0) ? -1 : 1); })[0];
    };
    /**
     * If we have information about which bundle types the discount applies to and it would not apply to the new bundle type we're creating, don't apply it.
     * Without this check, we can tell the user that they will get a discount which applied to their previous bundle type but on the backend fail to give them
     * that discount because the discount cannot apply to their new bundle type.
     */
    var discountAppliesToNewBundleType = function (appliesToBundleType, bundleType) {
        // if we got no information about which bundle types the discount applies to, assume that it applies to the provided bundle type
        if (!appliesToBundleType)
            return true;
        return appliesToBundleType.includes(bundleType);
    };
    return {
        finalSubmit: function (_a) {
            var addressId = _a.addressId, discountRecipeKey = _a.discountRecipeKey, bundleItemParams = _a.bundleItemParams, onetimeParams = _a.onetimeParams, shippingIntervalUnitType = _a.shippingIntervalUnitType, frequency = _a.frequency, bundleId = _a.bundleId, shopifyVariantId = _a.shopifyVariantId;
            return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // update the loading state variable
                            setIsCreatingNewBundleForExistingCustomer(true);
                            // create the new subscriptions and shopify order
                            return [4 /*yield*/, mutateAsync({
                                    addressId: addressId,
                                    quantity: 1,
                                    nextChargeScheduledAt: (0, date_fns_1.format)((0, date_fns_1.addDays)(new Date(), 3), 'yyyy-MM-dd'),
                                    shopifyVariantId: shopifyVariantId || bundleItemParams[0][0],
                                    intervalUnit: shippingIntervalUnitType,
                                    intervalFrequency: String(frequency),
                                    properties: [{ name: 'bundle_id', value: bundleId }],
                                    discountRecipeKey: discountRecipeKey,
                                    itemUpdates: (0, utils_1.convertItemsToItemUpdateInputs)(bundleItemParams),
                                    onetimes: onetimeParams ? (0, utils_1.convertItemsToItemUpdateInputs)(onetimeParams) : undefined,
                                })
                                // update the state variables
                            ];
                        case 1:
                            // create the new subscriptions and shopify order
                            _b.sent();
                            // update the state variables
                            setIsCreatingNewBundleForExistingCustomer(false);
                            setDidExistingCustomerCreateNewBundle(true);
                            return [2 /*return*/];
                    }
                });
            });
        },
        error: mutateError,
        isCreatingNewBundleForExistingCustomer: !ENABLE_EXISTING_CUSTOMER_NEW_BUNDLE_FLOW ? false : isCreatingNewBundleForExistingCustomer,
        didExistingCustomerCreateNewBundle: !ENABLE_EXISTING_CUSTOMER_NEW_BUNDLE_FLOW ? false : isCreatingNewBundleForExistingCustomer,
        queryParams: !ENABLE_EXISTING_CUSTOMER_NEW_BUNDLE_FLOW ? undefined : queryParams,
        discountRecipe: !ENABLE_EXISTING_CUSTOMER_NEW_BUNDLE_FLOW ? undefined : discountRecipe,
        getSavingsAndDiscount: getSavingsAndDiscount,
        // Even when this whole flow is disabled, callers sometimes want to know if the query params were present. Callers should rely on the truthiness of the
        // queryParams value to decide whether or not to actually use this flow for its original purpose.
        urlHasExistingCustomerNewBundleFlowQueryParams: !!queryParams,
    };
};
exports.useCreateNewBundle = useCreateNewBundle;
var templateObject_1;
